<template>
  <button v-bind="$attrs" class="m-basket-button" :class="shippingIndicatorClass" v-on="$listeners">
    <base-icon icon="bronnum-basket" />
    <span v-if="basketQuantity && basketQuantity > 0" class="m-basket-button__icon-counter">
      {{ basketQuantity }}
    </span>
  </button>
</template>

<script>
import BaseIcon from "@/components/atoms/BaseIcon";
export default {
  name: "BasketButton",
  components: {
    BaseIcon,
  },
  props: {
    basket: {
      type: Object,
      default: null,
    },
  },
  computed: {
    basketQuantity() {
      return (this.basket.orderSummary?.totalQuantity ?? 0) - (this.basket.addons?.length ?? 0);
    },
    shippingIndicatorClass() {
      const classes = {
        0: "-far",
        1: "-near",
        2: "-exceeded",
      };
      return classes[this.basket?.customProperties?.threshold] ?? "";
    },
  },
};
</script>
